import React, { useState } from 'react';
import { Stack, Tooltip } from '@mui/material';
import { Check, FileCopy } from '@mui/icons-material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconButton } from 'new/elements/IconButton/IconButton';
import styles from './ApplicationIdCell.module.scss';

type Props = {
  uuid: string;
};

export function ApplicationIdCell({ uuid }: Props) {
  const [copied, setCopied] = useState(false);

  if (!uuid) {
    return <span className={styles.emptyState}>—</span>;
  }

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Stack flexDirection="row" alignItems="center" gap="4px" minWidth={0} overflow="hidden">
      <Tooltip title={uuid} arrow placement="top">
        <span className={styles.idText}>{uuid}</span>
      </Tooltip>
      <CopyToClipboard text={uuid} onCopy={onCopy}>
        <IconButton aria-label="Copy Application ID" color="primary" className={styles.copyButton}>
          {copied ? <Check fontSize="small" /> : <FileCopy fontSize="small" />}
        </IconButton>
      </CopyToClipboard>
    </Stack>
  );
}
